// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"270620b8","656":"61a0d137","767":"53a25401","774":"d22bbbda","948":"eb7a2bef"}[chunkId] + ".chunk.js";
};